function Footer() {
    return (
        <div className="bg-black">
            <p className="text-white text-center">@Copyright 2025. Handcrafted by Gerry Yang with React JS and Tailwind CSS</p> 
        </div>
    )
}

export default Footer